/* unplugin-vue-components disabled */import { render } from "./TeacherCard.vue?vue&type=template&id=ab9b8c4a&scoped=true"
import script from "./TeacherCard.vue?vue&type=script&lang=js"
export * from "./TeacherCard.vue?vue&type=script&lang=js"

import "./TeacherCard.vue?vue&type=style&index=0&id=ab9b8c4a&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户湖南中医药大学-前端页面-saas/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab9b8c4a"]])

export default __exports__